/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

const EventForm = () => {
  // useEffect(() => {
  //   if (typeof document === 'undefined') {
  //     return;
  //   }

  //   // Mailchimp script initialization
  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src =
  //     '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
  //   document.body.appendChild(script);

  //   const inlineScript = document.createElement('script');
  //   inlineScript.type = 'text/javascript';
  //   inlineScript.text = `(function($) {
  //       window.fnames = new Array();
  //       window.ftypes = new Array();
  //       fnames[1]='FNAME';ftypes[1]='text';
  //       fnames[2]='LNAME';ftypes[2]='text';
  //       fnames[6]='COMPANY';ftypes[6]='text';
  //       fnames[7]='MMERGE7';ftypes[7]='text';
  //       fnames[0]='EMAIL';ftypes[0]='email';
  //       fnames[8]='MMERGE8';ftypes[8]='radio';
  //       fnames[3]='ADDRESS';ftypes[3]='address';
  //       fnames[4]='PHONE';ftypes[4]='phone';
  //       fnames[5]='BIRTHDAY';ftypes[5]='birthday';
  //       fnames[9]='MMERGE9';ftypes[9]='dropdown';
  //     }(jQuery));var $mcj = jQuery.noConflict(true);`;
  //   document.body.appendChild(inlineScript);
  // }, []);

  return (
    <>
      <div id={'mc_embed_shell'}>
        <link
          href={'//cdn-images.mailchimp.com/embedcode/classic-061523.css'}
          rel={'stylesheet'}
          type={'text/css'}
        />

        <div id={'mc_embed_signup'}>
          <form
            action={
              'https://boldare.us19.list-manage.com/subscribe/post?u=2ca0c62b4451a85205b77c8da&amp;id=73f0b8318a&amp;f_id=000b94e3f0'
            }
            method={'post'}
            id={'mc-embedded-subscribe-form'}
            name={'mc-embedded-subscribe-form'}
            className={'validate'}
            target={'_blank'}
          >
            <div id={'mc_embed_signup_scroll'}>
              <h2>Sign Up for Monthly Insights</h2>
              <div className={'indicates-required'}>
                <span className={'asterisk'}>*</span> indicates required
              </div>
              <div className={'mc-field-group'}>
                <label htmlFor={'mce-FNAME'}>
                  First Name <span className={'asterisk'}>*</span>
                </label>
                <input
                  type={'text'}
                  name={'FNAME'}
                  className={'required text'}
                  id={'mce-FNAME'}
                  required={''}
                  value={''}
                />
              </div>
              <div className={'mc-field-group'}>
                <label htmlFor={'mce-LNAME'}>
                  Last Name <span className={'asterisk'}>*</span>
                </label>
                <input
                  type={'text'}
                  name={'LNAME'}
                  className={'required text'}
                  id={'mce-LNAME'}
                  required={''}
                  value={''}
                />
              </div>
              <div className={'mc-field-group'}>
                <label htmlFor={'mce-COMPANY'}>
                  Company Name <span className={'asterisk'}>*</span>
                </label>
                <input
                  type={'text'}
                  name={'COMPANY'}
                  className={'required text'}
                  id={'mce-COMPANY'}
                  required={''}
                  value={''}
                />
              </div>
              <div className={'mc-field-group'}>
                <label htmlFor={'mce-MMERGE7'}>
                  Job Title <span className={'asterisk'}>*</span>
                </label>
                <input
                  type={'text'}
                  name={'MMERGE7'}
                  className={'required text'}
                  id={'mce-MMERGE7'}
                  required={''}
                  value={''}
                />
              </div>
              <div className={'mc-field-group'}>
                <label htmlFor={'mce-EMAIL'}>
                  Email Address <span className={'asterisk'}>*</span>
                </label>
                <input
                  type={'email'}
                  name={'EMAIL'}
                  className={'required email'}
                  id={'mce-EMAIL'}
                  required={''}
                  value={''}
                />
              </div>
              <div className={'mc-field-group input-group'}>
                <strong>
                  Agreement <span className={'asterisk'}>*</span>
                </strong>
                <ul>
                  <li>
                    <input
                      type={'radio'}
                      name={'MMERGE8'}
                      id={'mce-MMERGE80'}
                      value={
                        'I agree to the processing of my personal data in accordance with Boldare’s Privacy Policy.  I agree to receiving communications from Boldare,'
                      }
                      style={{ marginRight: '5px' }}
                    />
                    <label htmlFor={'mce-MMERGE80'}>
                      I agree to the processing of my personal data in
                      accordance with Boldare’s Privacy Policy. I agree to
                      receiving communications from Boldare,
                    </label>
                  </li>
                  <li>
                    <input
                      type={'radio'}
                      name={'MMERGE8'}
                      id={'mce-MMERGE81'}
                      value={
                        'including updates on events, business insights, and promotional materials about our services.'
                      }
                      style={{ marginRight: '5px' }}
                    />
                    <label htmlFor={'mce-MMERGE81'}>
                      including updates on events, business insights, and
                      promotional materials about our services.
                    </label>
                  </li>
                </ul>
              </div>
              <div id={'mce-responses'} className={'clear'}>
                <div
                  className={'response'}
                  id={'mce-error-response'}
                  style={{ display: 'none' }}
                />
                <div
                  className={'response'}
                  id={'mce-success-response'}
                  style={{ display: 'none' }}
                />
              </div>
              <div
                aria-hidden={'true'}
                style={{ position: 'absolute', left: '-5000px' }}
              >
                <input
                  type={'text'}
                  name={'b_2ca0c62b4451a85205b77c8da_73f0b8318a'}
                  tabIndex={'-1'}
                  value={''}
                />
              </div>
              <div className={'clear'}>
                <input
                  type={'submit'}
                  name={'subscribe'}
                  id={'mc-embedded-subscribe'}
                  className={'button'}
                  value={'Subscribe'}
                />
              </div>
            </div>
          </form>
        </div>
        <script
          type={'text/javascript'}
          src={'//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'}
        />
      </div>
    </>
  );
};

export default EventForm;
